var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#9954A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1767 6.0902C17.1379 6.0556 17.092 6.02992 17.0422 6.01499C16.9924 6.00005 16.9399 5.99622 16.8885 6.00376L10.3285 6.86498C10.2405 6.87655 10.1596 6.91954 10.1008 6.98602C10.042 7.05249 10.0091 7.13799 10.0084 7.22675V14.3086C9.55264 13.9165 8.97034 13.7027 8.36916 13.7067C7.06293 13.7067 6 14.6672 6 15.8518C6 17.0363 7.06293 18 8.36916 18C9.6754 18 10.7383 17.0395 10.7383 15.8518V9.3686L16.5683 8.60022V12.3909C16.1277 12.0197 15.5693 11.8177 14.9932 11.821C13.7126 11.821 12.6881 12.759 12.6881 13.9116C12.6881 15.0642 13.7222 16.0022 14.9932 16.0022C16.2642 16.0022 17.2983 15.0642 17.2983 13.9116V6.36554C17.2988 6.31363 17.2882 6.26222 17.2672 6.21474C17.2462 6.16726 17.2153 6.1248 17.1767 6.0902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audioIcon.09ecf3525e7783953ec7e26e14624d0b.svg";
export { ForwardRef as ReactComponent };